export default "__VITE_ASSET__9779e2f0__"